<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
          today
        </mat-icon>
        <span class="logo-text h1" *fuseIfOnDom
        [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'main.released_event' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
        <label for="search" class="mr-8">
          <mat-icon class="secondary-text">search</mat-icon>
        </label>

        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->
        <mat-form-field floatLabel="never" fxFlex="1 0 auto" style="display: none">
          <input id="search1" autocomplete="off" matInput #filter2 placeholder="{{'main.search' | translate}}">
        </mat-form-field>
        <!-- USE IT TO BLOCK CHROME AUTOCOMPLETE -->

        <mat-form-field floatLabel="never" fxFlex="1 0 auto" class="page-search">
          <mat-label>{{'main.search' | translate}}</mat-label>
          <input id="search" (keyup)="applyFilter($event.target.value)" matInput #filter>
        </mat-form-field>
      </div>
      <!-- / SEARCH -->
    </div>
    <!-- / HEADER -->


    <!-- CONTENT -->
    <div class="content-card mat-white-bg">
      <mat-table class="products-table"
        #table [dataSource]="events"
        matSort
        [@animateStagger]="{value:'50'}"
        fusePerfectScrollbar>


        <!-- Name Column -->
        <ng-container cdkColumnDef="title">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let event">
            <p class="text-truncate">{{event.title}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="country">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.country' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let event">
            <img style="height: 40px" [src]="'assets/images/' + event.country.flag + '.svg'"/>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="canton" >
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'main.canton' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let event">
            <p class="text-truncate">{{event.city.name}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="organization" >
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'main.organization' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let event">
            <p class="text-truncate">{{event.organization.name}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="reserveCount" >
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'main.reserveCount' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let event">
            <p class="text-truncate">{{event.reservePlace}}</p>
          </mat-cell>
        </ng-container>

        @if (isOrganizer) {
          <ng-container cdkColumnDef="subscription">
            <mat-header-cell *cdkHeaderCellDef mat-sort-header>abonniert</mat-header-cell>
            <mat-cell *cdkCellDef="let event">
              @if (event.subscription) {
                <img style="height: 40px" src="../../../../assets/images/subscribe.svg">
              }
            </mat-cell>
          </ng-container>
        }

        <ng-container cdkColumnDef="date">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'event.event_start' | translate}}</mat-header-cell>
          <mat-cell *cdkCellDef="let event">
            <p   matTooltip="{{event.dateForShow}}" class="text-truncate">{{event.dateForShow}}</p>
          </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="type">
          <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'organization.organizationType' | translate}}
          </mat-header-cell>
          <mat-cell *cdkCellDef="let event">
            <p class="text-truncate" [ngStyle]="{'border-bottom' : '2px solid ' + event.eventType.color}"><span
            [ngStyle]="{'background-color' : event.eventType.color}"></span>{{event.eventType.name}}
          </p>
        </mat-cell>
      </ng-container>


      <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>


      <mat-row *cdkRowDef="let event; columns: displayedColumns;"
        class="product"
        matRipple
        [routerLink]="'/pages/event/detail'" [queryParams]="{id: event.id}">
      </mat-row>

    </mat-table>
    @if (events?.filteredData?.length === 0) {
      <div class="no-data-msg">
        <span class="mat-headline-6">{{'main.noData' | translate}}</span>
      </div>
    }
    <mat-paginator #paginator
      [length]="events?.filteredData?.length"
      [pageIndex]="0"
      [pageSize]="50"
      [pageSizeOptions]="[25, 50, 100]">
    </mat-paginator>

  </div>
  <!-- / CONTENT -->

</div>
</div>



